import { Routes, Route } from 'react-router-dom';
import { I18nProvider } from './i18n';
import { PWAInstallPrompt } from './components/PWAInstallPrompt';
import { DebugLog } from './components/DebugLog';
import HomePage from './pages/HomePage';
import ClipPage from './pages/ClipPage';

function AppRoutes() {
  return (
    <Routes>
      {/* Chinese routes (default) */}
      <Route path="/" element={<HomePage />} />
      <Route path="/c/:uuid" element={<ClipPage />} />

      {/* English routes */}
      <Route path="/en" element={<HomePage />} />
      <Route path="/en/c/:uuid" element={<ClipPage />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <AppRoutes />
        <PWAInstallPrompt />
        <DebugLog />
      </div>
    </I18nProvider>
  );
}

export default App;
